import React from 'react';

import styles from './HeaderBack.module.css';
import { useNavigate } from 'react-router-dom';

export default function HeaderBack() {
  const navigate = useNavigate();

  return (
    <div className={styles.header_wrapper}>
      <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
        <svg
          width="12"
          height="18"
          viewBox="0 0 12 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
        </svg>
        Назад
      </div>
    </div>
  );
}
